export default {
  computed: {
    computed_headers() {
      const headers = { "Content-Type": "application/json" };
      if (this.token) headers.Authorization = `Token ${this.token}`;
      if (this.csrfToken) headers["X-CSRFToken"] = this.csrfToken;
      return headers;
    },

    table_safe_conditions() {
      return this.rule_conditions.map(condition => ({
        ...condition,
        value: condition.value || "-",
        comparison_value: condition.comparison_value || "-",
        selected_options: condition.selected_options || [],
        version: condition.version || 1,
      }));
    },

    condition_types() {
      return this.condition_type_options.length > 0
        ? this.condition_type_options.map(type => ({ value: type.value, label: type.label }))
        : [
            { value: "1", label: "Question Response" },
            { value: "2", label: "Time Based" },
            { value: "3", label: "User Role" },
            { value: "4", label: "Checklist Item" },
            { value: "5", label: "Status Based" },
          ];
    },

    filtered_operators() {
      return this.operator_options.length > 0
        ? this.operator_options.map(op => ({ value: op.value, label: op.label }))
        : this.get_default_operators();
    },

    logical_operators() {
      return [
        { value: "AND", label: "AND (All conditions must be true)" },
        { value: "OR", label: "OR (At least one condition must be true)" },
        { value: "NOT", label: "NOT (Condition must be false)" },
        { value: "XOR", label: "XOR (Exactly one condition must be true)" },
        { value: "NAND", label: "NAND (Not all conditions true)" },
      ];
    },

    should_show_value_input() {
      if (!this.condition_form.operator) return true;

      const operatorStr = this.get_operator_string(this.condition_form.operator);
      const is_multi_select = ["in", "not_in", "12", "13"].includes(operatorStr);
      const is_between = operatorStr === "between" || this.condition_form.operator === "7";

      return !is_multi_select && !is_between;
    },

    should_show_value_max() {
      if (!this.condition_form.operator) return false;
      const operatorStr = this.get_operator_string(this.condition_form.operator);
      return operatorStr === "between" || this.condition_form.operator === "7";
    },

    should_show_compliance_field() {
      const conditionTypeStr = this.get_condition_type_string(this.condition_form.condition_type);
      return conditionTypeStr === "question_response" || this.condition_form.condition_type === "1";
    },

    should_show_result_action_question() {
      const conditionTypeStr = this.get_condition_type_string(this.condition_form.condition_type);
      return conditionTypeStr === "question_response" || this.condition_form.condition_type === "1";
    },

    should_show_checklist_item() {
      const conditionTypeStr = this.get_condition_type_string(this.condition_form.condition_type);
      return conditionTypeStr === "checklist_item" || this.condition_form.condition_type === "4";
    },
  },
};
